import { ColumnFilters } from "src/app/common/column-filters";
import { Component, ElementRef, OnInit, inject, viewChild, signal, ViewEncapsulation } from "@angular/core";
import { Blog } from '../../models/blog';
import { ConfirmationService, TreeNode, PrimeTemplate } from 'primeng/api';
import { CategoryService } from '../../services/categories.service';
import { Category } from '../../models/category';
import { MessageService } from 'primeng/api';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { ComuniService } from 'src/app/services/comuni.service';
import { Comuni } from 'src/app/models/comuni';
import { BillingsService } from 'src/app/services/billings.service';
import { jsPDF } from "jspdf";
import { NgxSpinnerService } from "ngx-spinner";
import { Orders } from 'src/app/models/orders';
import { OrdersService } from 'src/app/services/orders.service';
import { PARAM_BILLINGS_PATH, PARAM_DOCUMENTS_PATH, PARAM_ORDERS_PATH } from '../../constants/constants';
import { Billings } from 'src/app/models/billings';
import { DocumentsService } from 'src/app/services/documents.service';
import { Documents } from 'src/app/models/documents';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { DatePicker } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { RouterLink } from '@angular/router';
import { Card } from 'primeng/card';
import { Tree } from 'primeng/tree';
import { SlicePipe, CurrencyPipe, DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { InitialsAvatarComponent } from '../../components/initials-avatar/initials-avatar.component';
import { Tag } from 'primeng/tag';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { Toast } from 'primeng/toast';
import { TranslatePipe } from '@ngx-translate/core';
import { KeysPipe } from '../../pipe/key.pipe';

@Component({
    standalone: true,
    selector: "app-manage-documents",
    templateUrl: "./manage-documents.component.html",
    styleUrl: "./manage-documents.component.less",
    encapsulation: ViewEncapsulation.None,
    imports: [Bind, Drawer, PrimeTemplate, DatePicker, FormsModule, ButtonDirective, TopNavComponent, RouterLink, Card, Tree, TableModule, NgxPaginationModule, InitialsAvatarComponent, Tag, ConfirmDialog, Toast, SlicePipe, CurrencyPipe, DatePipe, TranslatePipe, KeysPipe]
})
export class ManageDocumentsComponent extends ColumnFilters implements OnInit {
  private clientsService = inject(ClientsService);
  private ordersService = inject(OrdersService);
  private messageService = inject(MessageService);
  private comuniService = inject(ComuniService);
  private documentsService = inject(DocumentsService);
  private categoryService = inject(CategoryService);
  private billingsService = inject(BillingsService);
  private confirmationService = inject(ConfirmationService);
  private spinner = inject(NgxSpinnerService);

  orders: any = [];
  readonly order = signal<Orders>(undefined);
  readonly filterSidebar = signal<boolean>(undefined);
  readonly documents = signal<any>([]);
  document: Documents;

  categories: any = [];
  category: Category;
  readonly error = signal<string>(undefined);
  private category_id: string;
  private id: string;
  readonly clients = signal<any>([]);
  client: Clients;
  readonly comuni = signal<any>([]);
  readonly roomDialog = signal<boolean>(false);
  readonly selectedSkills = signal<any[]>(undefined);
  skills: any[] = [];
  skillsArray: any = [];

  readonly cols = signal<any[]>(undefined);
  readonly exportColumns = signal<any[]>(undefined);
  readonly _selectedColumns = signal<any[]>(undefined);
  billings:  any = [];
  readonly page = signal(1);
  readonly count = signal(0);
  readonly pageSize = signal(10);
  pageSizes = [5, 10, 15];
  public base_path: string;
  basePath: string;
  readonly pageOfItems = signal<Array<any>>(undefined);
  searchWrapper: boolean = false;
  readonly content = viewChild<ElementRef>("content");
  readonly currentUser = signal<any>(undefined);
  readonly files = signal<TreeNode[]>(undefined);
  readonly loading = signal(true);
  readonly nodeTitle = signal<any>(undefined);

  showDialog() {
    this.roomDialog.set(true);
  }

  trackByFn(index, item) {
    return item.id;
  }

  constructor() {
    super();
    this.files.set([
        {
          "label": "Documents",
          "key": "102",
          "data": "Documents Folder",
          "expandedIcon": "pi pi-folder-open",
          "collapsedIcon": "pi pi-folder",
          "children": [{
            "label": "Work",
            "data": "Work Folder",
            "key": "2",
            "expandedIcon": "pi pi-folder-open",
            "collapsedIcon": "pi pi-folder",
            "children": [{
              "label": "Work",
              "data": "Work Folder",
              "key": "2",
              "expandedIcon": "pi pi-folder-open",
              "collapsedIcon": "pi pi-folder",
              "children": []
            },
            {
              "label": "Home",
              "key": "121",
              "data": "Home Folder",
              "expandedIcon": "pi pi-folder-open",
              "collapsedIcon": "pi pi-folder",
              "children": []
            }]
          },
          {
            "label": "Home",
            "key": "102",
            "data": "Home Folder",
            "expandedIcon": "pi pi-folder-open",
            "collapsedIcon": "pi pi-folder",
            "children": []
          }]
        },
      ])

      this.loading.set(false);

  }

  ngOnInit() {

    this.currentUser.set(JSON.parse(localStorage.getItem('currentUser') || '[]'));
    const userId = this.currentUser().user_id;

    this.cols.set([
      { field: "category_id", header: "Cliente" },
      { field: 'client.username', header: 'Nome Cliente' },
      { field: "id", header: "Numero Fattura" },
    ]);
    this._selectedColumns.set(this.cols());
    this.exportColumns.set(this.cols().map(col => ({
      title: col.header,
      dataKey: col.field
    })));
    this.load(this.files()[0]);

  }

  nodeSelect(event) {
    this.load(event.node);
}

  load(node): void {

    const id = node.key;
    this.nodeTitle.set(node.label);
    const params = this.getRequestParams(
      this.filter("name"),
      this.filter("description"),
      this.page(),
      this.pageSize()
    );

    this.documentsService.getAllListDocuments(params, id).subscribe((pData) => {
      this.documents.set(pData);
      this.count.set(this.documentsService.size);

    });
  }

  getRequestParams(searchTitle, categoryTitle, page, pageSize): any {

    let path = PARAM_DOCUMENTS_PATH;
    const params = {};
    let adder = '?';
    if (page) {
      params[`page`] = page - 1;
      path += adder + 'page=' + (page - 1);
      adder = '&';
    }
    if (searchTitle) {
      params[`name`] = searchTitle;
      path += adder + 'date_from=' + searchTitle;
      adder = '&';
    }
    if (categoryTitle) {
      params[`description`] = categoryTitle;
      path += adder + 'date_to=' + categoryTitle;
      adder = '&';
    }
    if (pageSize) {
      params[`size`] = pageSize;
      path += adder + 'size=' + pageSize;
    }

    return params;

  }

  handlePageSizeChange(event, node): void {
    this.pageSize.set(event.target.value);
    this.page.set(1);
    this.load(node);
  }

  reset(node): void {
    this.setFilter("name", '');
    this.setFilter("description", '');
    this.load(node);

  }

  public handlePageChange(event,node): void {
    this.page.set(event);
    this.load(node);

  }

  onChangePage(pageOfItems: Array<any>) {

    this.pageOfItems.set(pageOfItems);
  }

  private onChange(item: string, node): void {
    this.load(node);

  }

  getClients() {
    const userId = this.currentUser().user_id;
    this.clientsService.getAllListbyUser().subscribe(
      (data: Clients) => this.clients.set(data),
      error => this.error.set(error)
    );

  }

  getComuni() {
    this.comuniService.getAllList().subscribe(
      (data: Comuni) => (this.comuni.set(data)),
      (error) => (this.error.set(error))
    );

  }

  getCategoryItem(category_id: string, id: string) {
    return this.clients().find((item) => item.id === category_id);
  }

  getComuniItem(category_id: string, id: string) {
    return this.comuni().find((item) => item.id === category_id);
  }

  edit(order: Orders) {
    this.order.set({ ...order });
    this.selectedSkills.set(JSON.parse("" + this.order().skills + ""));
    this.roomDialog.set(true);
  }

  hideDialog() {
    this.roomDialog.set(false);
  }

  onDelete(id: string, title: string) {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare = " + id,
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.ordersService.delete(id).subscribe(
          (res) => {
            console.log(res);
            this.ngOnInit();
            this.messageService.add({
              key: "myKey1",
              severity: "warn",
              summary: "Attenzione",
              detail: "Cancellazione avvenuto con successo",
            });
          },
          (error) => (this.error.set(error))
        );
      },
    });
  }
}
